import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class CampaignsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(params) {
    return super.getList(params);
  }
  createItem(params) {
    return this.http.post('', params);
  }

  getItem(id) {
    return this.http.get(`/${id}`);
  }

  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }

  deleteItem(id) {
    return this.http.put(`/${id}/complete`);
  }

  getScheme(id) {
    return this.http.get(`/${id}/schema`);
  }

  initScheme(id, template) {
    return this.http.post(`/${id}/schema/init`, { template });
  }

  getSelect() {
    return this.http.get(`/select`);
  }

}

export const CampaignsService = new CampaignsServiceClass({
  api_version: 2,
  resource: 'informer/campaigns'
});
